module.exports = __webpack_public_path__ + "img/zbthsl.cbed85c0.png";